var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { DependencyInjectionContext } from './DependencyInjectionContext';
export const useDependency = (key) => {
    _react_refresh_temp_1();
    const dependencyInjectionValue = useContext(DependencyInjectionContext);
    if (!dependencyInjectionValue) {
        throw new Error('Dependency injection context not available!');
    }
    const dependency = dependencyInjectionValue[key];
    if (dependency === undefined) {
        throw new Error(`Could not find a dependency with this key: ${key}!`);
    }
    return dependency;
};
_react_refresh_temp_1(useDependency, "OyvwRXHWEAR7W7OoPpifFF/w4hE=");
